import FindUsersPage from './FindUsersPage';

export default FindUsersPage;